<template lang="pug">
box
  page-title(slot="page-title", title="Mensagem recebida")
  load-manager.scrollable(slot="content", :loading="loading", :errors="errors")
    .container.grid-lg.pb-2.mb-2(v-if="current")
      show-mensagem(:mensagem="mensagem")
      recursive-messages(:mensagem="mensagem")
      .columns
        .column.col-auto(v-if="mensagem.permite_responder")
          router-link.btn.btn-link(
            :to="{ name: 'app.mensagens.recebida.responder' }"
          )
            i.fa.fa-reply
            span &nbsp;Responder
          router-view
        .column.col-auto
          a.btn.btn-link(
            v-if="mensagem.arquivada_destinatario",
            @click="restaurar"
          )
            i.fa.fa-refresh
            |
            | Restaurar
          a#arquivar.btn.btn-link.text-warning(@click="checkArchive", v-else)
            i.fa.fa-archive
            span &nbsp;Arquivar
</template>

<script>
import showMixin, { defaultStoreImports } from "@/mixins/show";
import ShowMensagem from "../Mensagem.vue";
import RecursiveMessages from "../RecursiveMessages.vue";
import Mensagem from "@/models/Mensagem";
import toastErrors from "@/lib/errors/toastErrors";
import api from "@/api/mensagens/recebidas";

export default {
  vuex: {
    "mensagens/recebidas": {
      ...defaultStoreImports,
      actions: [
        "fetchOne",
        "fetchResponder",
        "fetchArquivar",
        "fetchRestaurar",
        "fetchCount",
      ],
    },
  },
  computed: {
    mensagem() {
      return this.current ? new Mensagem(this.current) : null;
    },
  },
  methods: {
    async onEndCreated() {
      if (this.mensagem && this.mensagem.permite_ler) {
        await api.ler(this.mensagem.id);
        this.fetchCount();
      }
    },
    async checkArchive() {
      const options = {
        title: "Arquivar",
        cancelLabel: "Não",
        okLabel: "Sim",
        size: "sm",
      };
      const res = await this.$dialogs.confirm(
        "Deseja arquivar essa mensagem?",
        options
      );
      if (res.ok) {
        await this.arquivar();
      }
    },
    async arquivar() {
      try {
        await this.fetchArquivar(this.mensagem.id);
        this.$toaster.success("Mensagem arquivada");
        this.$router.replace(`/app/mensagens`);
      } catch (e) {
        toastErrors(e);
      }
    },
    async restaurar() {
      const { ok } = await this.$dialogs.confirm(
        "Deseja restaurar a mensagem?",
        {
          title: "Restaurar mensagem",
          cancelLabel: "Não",
          okLabel: "Sim",
          size: "sm",
        }
      );

      if (ok) {
        try {
          await this.fetchRestaurar(this.current.id);
          this.$toaster.success("Mensagem restaurada");
          this.$router.back();
        } catch (e) {
          toastErrors(e);
        }
      }
    },
  },
  mixins: [showMixin],
  components: { ShowMensagem, RecursiveMessages },
};
</script>
